<template>
    <a href="#" v-if="isaudio" @click="playaudio(audio)">
        <span v-html="content"></span>
    </a>
    <span v-else v-html="content"></span>
</template>

<script>
    export default {
        name: 'Ctdlinfo',
        props: {
            audio: {
                type: String,
                default: ''
            },
            content: {
                type: String,
                default: ''
            }
        },
        computed: {
            isaudio: function () {
                if (this.audio) {
                    return this.audio.indexOf('mp3') > 0;
                }
                return false;
            }
        },
        methods: {
            playaudio: function (v) {
                this.$emit('playaudio', v);
            }
        }

    }
</script>
